import _ from 'lodash';
import createReactClass from 'create-react-class';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { CustomerContextProvider } from 'components/customer/customer_context';
import { getLatestConversationId } from 'actions/conversation/lib/conversation_helpers';
import AnswerPanelToggleButton from 'components/customer/answer_panel/answer_panel_toggle_button';
import Composition from './customer/composition';
import connect from 'components/lib/connect';
import ConversationHistory from 'components/customer/conversation_history/conversation_history';
import CustomerFooter from 'components/customer/customer_footer';
import CustomerNotAssignedToCurrentAgentBanner from 'components/customer/customer_not_assigned_to_current_agent_banner';
import CustomerNotFound from 'components/customer/customer_not_found';
import CustomerPageViewedTracker from 'components/customer/customer_page_viewed_tracker';
import CustomerSidePanel from 'components/customer/customer_side_panel';
import CustomerSummary from 'components/customer/customer_summary';
import CustomerWasCombined from 'components/customer/customer_was_combined';
import GreetingSuggestionsProvider from 'components/composer/contexts/greeting_suggestions_context';
import KeyPressShortcutMixin from 'components/lib/keypress_shortcut_mixin';
import OpenAnswerPanel from 'actions/answers/open_answer_panel';
import PhraseSuggestionsProvider from 'components/composer/contexts/phrase_suggestions_context';
import registerHotkey from 'components/hotkeys/register_hotkey';
import SwitchToInbox from 'actions/inbox/switch_to_inbox';
import TaskCommentPanelToggleButton from 'components/customer/task_comments/task_comment_panel_toggle_button';
import TeamAssistPanelToggleButton from 'components/customer/team_assist/team_assist_panel_toggle_button';
import ToggleAnswerPanel from 'actions/answers/toggle_answer_panel';
import useIsTeamFlagEnabled from 'components/hooks/use_is_team_flag_enabled';
import VariablesProvider from 'components/composer/contexts/variables_context';
import withShortcuts from 'scripts/presentation/decorators/keypress_shortcut_decorator';
import SidePanel, { SidePanelType } from 'models/side_panel';

const Customer = createReactClass({
  mixins: [new KeyPressShortcutMixin()],

  propTypes: {
    currentAgentId: PropTypes.string,
    customerExists: PropTypes.bool,
    customerId: PropTypes.string.isRequired,
    hasConversationGeneral: PropTypes.bool,
    hasSelectedTask: PropTypes.bool,
    isAnswersReadEnabled: PropTypes.bool,
    isFullHeightSidePanel: PropTypes.bool,
    latestConversationId: PropTypes.string,
    onInboxShortcut: PropTypes.func,
    openAnswerPanel: PropTypes.func,
    sidePanel: PropTypes.instanceOf(SidePanel),
    toggleAnswerPanel: PropTypes.func,
  },

  render() {
    return (
      <div className="customerV2Container" id="customer">
        {this.renderCustomer()}
      </div>
    );
  },

  renderCustomer() {
    if (this.props.mergedCustomerId) {
      return <CustomerWasCombined customerId={this.props.mergedCustomerId} />;
    } else if (!this.props.customerExists) {
      return <CustomerNotFound />;
    }

    const contentArea = (
      <CustomerAssignmentBannerWrapper>
        <CustomerNotAssignedToCurrentAgentBanner />
        <CustomerContent>
          <CustomerSummary />
          <ConversationFeed
            currentCompositionId={this.props.currentCompositionId}
            customerId={this.props.customerId}
            hasSelectedTask={this.props.hasSelectedTask}
            isAnswersReadEnabled={this.props.isAnswersReadEnabled}
            onToggleAnswerPanel={this.handleToggleAnswerPanel}
            sidePanel={this.props.sidePanel}
          />
        </CustomerContent>
      </CustomerAssignmentBannerWrapper>
    );

    const footer = this.props.hasConversationGeneral ? (
      <CustomerFooter isCompactMode={this.props.isFullHeightSidePanel} />
    ) : null;

    if (this.props.isFullHeightSidePanel) {
      return (
        <CustomerProviders>
          <CustomerPage>
            <CustomerPageViewedTracker customerId={this.props.customerId} />
            <CustomerOuterWrapper>
              <CustomerLeftColumn>
                <CustomerAnswerWrapper>{contentArea}</CustomerAnswerWrapper>
                {footer}
              </CustomerLeftColumn>
              <CustomerSidePanel />
            </CustomerOuterWrapper>
          </CustomerPage>
        </CustomerProviders>
      );
    }

    return (
      <CustomerProviders>
        <CustomerPage>
          <CustomerPageViewedTracker customerId={this.props.customerId} />
          <CustomerAnswerWrapper>
            {contentArea}
            <CustomerSidePanel />
          </CustomerAnswerWrapper>
          {footer}
        </CustomerPage>
      </CustomerProviders>
    );
  },

  handleInboxShortcut() {
    this.props.onInboxShortcut();
  },

  handleOpenAnswerPanel() {
    this.props.openAnswerPanel({
      customerId: this.props.customerId,
      conversationId: this.props.latestConversationId,
      compositionId: undefined,
    });
  },

  handleToggleAnswerPanel() {
    this.props.toggleAnswerPanel({
      conversationId: this.props.latestConversationId,
      customerId: this.props.customerId,
      compositionId: undefined,
    });
  },
});

const CustomerPage = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  height: inherit;
  min-width: 0;
  position: relative;
`;

const CustomerAnswerWrapper = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: row;
  height: 100%;
  min-height: 0;
  position: relative;
`;

const CustomerOuterWrapper = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: row;
  height: 100%;
  min-height: 0;
  position: relative;
`;

const CustomerLeftColumn = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
`;

const CustomerAssignmentBannerWrapper = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  min-width: 0;
  position: relative;
`;

const CustomerContent = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1 1 auto;
  height: 100%;
  min-height: 0;
  position: relative;
`;

const CustomerWithShortcuts = withShortcuts(Customer, [
  registerHotkey({
    key: 'alt+i',
    callback: component => component.handleInboxShortcut(),
    label: 'Go back to inbox',
    group: 'Customer',
  }),
  registerHotkey({
    key: 'ctrl+/',
    callback: component => component.handleOpenAnswerPanel(),
    label: 'Open answers side panel',
    group: 'Customer',
  }),
]);

export { Customer, CustomerWithShortcuts };

const CustomerContainer = connect(mapStateToProps, mapExecuteToProps)(CustomerWithShortcuts);

CustomerContainer.propTypes = {
  customerId: PropTypes.string.isRequired,
};

export default CustomerContainer;

function mapStateToProps({ getProvider, isFeatureEnabled }, { customerId }) {
  const customerMerge = getProvider('customerMerge').get();
  const mergedCustomerId =
    customerMerge && _.get(customerMerge, 'sourceCustomerId') === customerId && _.get(customerMerge, 'destCustomerId');

  let latestConversationId = getLatestConversationId(getProvider('conversations'));
  const profileProvider = getProvider('profile');
  const customerProfileExists = profileProvider.isLoading() || !!profileProvider.get();
  const isAnswersReadEnabled = isFeatureEnabled('answers:read');

  return {
    activeCall: getProvider('activeCall').get(),
    currentAgentId: getProvider('currentAgent').get().id,
    currentCompositionId: getProvider('currentLocation').get().currentCompositionId,
    customerExists: customerProfileExists,
    customerId,
    hasConversationGeneral: isFeatureEnabled('conversation:general'),
    hasSelectedTask: !!getProvider('commentPanel').get().selectedItemId,
    isAnswersReadEnabled,
    isFullHeightSidePanel: isFeatureEnabled('fullHeightSidePanel'),
    latestConversationId,
    mergedCustomerId,
    sidePanel: getProvider('sidePanel').get(),
  };
}

function mapExecuteToProps(executeAction) {
  return {
    onInboxShortcut: () => executeAction(SwitchToInbox),
    openAnswerPanel,
    toggleAnswerPanel,
  };

  function toggleAnswerPanel(attrs) {
    executeAction(ToggleAnswerPanel, attrs);
  }

  function openAnswerPanel(attrs) {
    executeAction(OpenAnswerPanel, attrs);
  }
}

function CustomerProviders({ children }) {
  return (
    <CustomerContextProvider>
      <VariablesProvider>
        <GreetingSuggestionsProvider>
          <PhraseSuggestionsProvider>{children}</PhraseSuggestionsProvider>
        </GreetingSuggestionsProvider>
      </VariablesProvider>
    </CustomerContextProvider>
  );
}

export function ConversationFeed({
  currentCompositionId,
  customerId,
  hasSelectedTask,
  isAnswersReadEnabled,
  onToggleAnswerPanel,
  sidePanel,
}) {
  const isTeamFlagEnabled = useIsTeamFlagEnabled();
  const isTeamAssistEnabled = isTeamFlagEnabled('teamAssistAI');

  const isAnswerPanelOpen = sidePanel.isShowing(SidePanelType.ANSWER);
  const isTeamAssistPanelOpen = sidePanel.isShowing(SidePanelType.AI_ASSIST);
  const isCommentPanelOpen = sidePanel.isShowing(SidePanelType.TASK);
  const isAnyPanelOpen = sidePanel.isOpen();

  return (
    <div className="customerV2-feed customerV2-flatFeed">
      <PanelToggleStack>
        {isTeamAssistEnabled && (
          <TeamAssistPanelToggleButton
            isActive={isTeamAssistPanelOpen || sidePanel.isShowing(SidePanelType.NONE)}
            isPanelOpen={isAnyPanelOpen}
          />
        )}
        {isAnswersReadEnabled && (
          <AnswerPanelToggleButton
            isActive={isAnswerPanelOpen || sidePanel.isShowing(SidePanelType.NONE)}
            isPanelOpen={isAnyPanelOpen}
            onToggleAnswerPanel={onToggleAnswerPanel}
          />
        )}
        <TaskCommentPanelToggleButton isActive={isCommentPanelOpen} isVisible={hasSelectedTask} />
      </PanelToggleStack>
      <ConversationHistory customerId={customerId} />
      <Composition currentCompositionId={currentCompositionId} />
    </div>
  );
}

const PanelToggleStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  position: absolute;
  right: 0;
  top: 13px;
  z-index: 6;
`;

ConversationFeed.propTypes = {
  currentCompositionId: PropTypes.string,
  customerId: PropTypes.string.isRequired,
  hasSelectedTask: PropTypes.bool,
  isAnswersReadEnabled: PropTypes.bool,
  onToggleAnswerPanel: PropTypes.func.isRequired,
  sidePanel: PropTypes.instanceOf(SidePanel),
};
